/**
 * Marquee
 */

// Vendors
import $ from 'jquery';
import Player from '@vimeo/player';
import Plyr from 'plyr';
import { debounce } from 'lodash';

// Components
import carousel from '../framework/carousel';

// Utilities
import { scrollToElement } from '../lib/utilities';

const oldMarquee =
  $('.marquee--home').length ||
  $('.marquee--archive').length ||
  $('.marquee--default').length ||
  $('.marquee--default-slim').length ||
  $('.marquee--detail').length ||
  $('.marquee--inverted').length;

// Set marquee diamond image height.
const setMarqueeImageHeight = () => {
  $('.marquee__slide--active .marquee__media-image').each((index, element) => {
    const $this = $(element);

    if (window.innerWidth > 991) {
      const marqueeHeight = $this.parents('.marquee').outerHeight();
      const isFrontpage = $this.parents('.marquee').hasClass('marquee--home');
      const multiplier = 1.2;

      $this.attr(
        'style',
        `height: ${parseInt(marqueeHeight * multiplier)}px!important;`
      );
    } else {
      $this.attr('style', '');
    }
  });
};

// ..and window resize.
if (oldMarquee) {
  window.addEventListener(
    'resize',
    debounce(
      () => {
        setMarqueeImageHeight();
      },
      50,
      { maxWait: 250 }
    )
  );
}

// Trigger marquee init.
$(document).ready(() => {
  $('.marquee').addClass('marquee--initialized');

  if ($('.marquee__slide--initial').length) {
    $('.marquee__slide--initial')
      .addClass('marquee__slide--active')
      .removeClass('marquee__slide--initial');
  } else {
    $(`[data-marquee-slide="0"]`).addClass('marquee__slide--active');
  }

  if (oldMarquee) {
    setMarqueeImageHeight();
  }
});

// Video related stuff
$(document).ready(() => {
  $('body').click(); // allow for autoplay
  $('.marquee__media-video').each((index, element) => {
    const $this = $(element);
    const $container = $this.closest('.marquee__media');
    const videoPlatform = $this.data('provider');
    const player =
      videoPlatform === 'vimeo'
        ? new Player($this.find('iframe'))
        : new Plyr($this.find('[data-plyr-embed-id]'), {
            debug: false,
            hideControls: true,
            controls: [],
            loadSprite: false,
            autoplay: true,
            muted: true,
            loop: { active: true }
          });

    player.play();

    player.on('timeupdate', (data) => {
      if (videoPlatform === 'vimeo') {
        if (data.seconds < 2) return;
      } else {
        if (data.timeStamp < 10000) return;
      }

      if ($container.hasClass('marquee__media--video-played')) return;

      $container.addClass('marquee__media--video-played');
    });
  });
});

// Smooth scroll to anchors
$(document).on('click', '.marquee__text-body a[href^="#"]', (event) => {
  event.preventDefault();
  const target = $(event.currentTarget).attr('href');
  if (target.length > 1 && $(target).length > 0) {
    scrollToElement($(target));
  }
});

$(document).on('click', '.marquee__nav .marquee__thumb', (event) => {
  event.preventDefault();
  const self = $(event.currentTarget);
  const marquee = self.closest('.marquee');
  const slideNextIndex = self.data('marquee-thumb');
  const slideCurrent = marquee.find('.marquee__slide--active');
  const navCurrent = marquee.find('.marquee__thumb--active');
  const slideNext = marquee.find(`[data-marquee-slide="${slideNextIndex}"]`);
  const navNext = marquee.find(`[data-marquee-thumb="${slideNextIndex}"]`);

  slideCurrent.removeClass('marquee__slide--active');
  navCurrent.removeClass('marquee__thumb--active');
  slideNext.addClass('marquee__slide--active');
  navNext.addClass('marquee__thumb--active');

  setMarqueeImageHeight();
});

$('[data-resource-gallery-carousel]').each((index, element) => {
  const galleryId = $(element).data('resource-gallery-carousel');

  const resourceCarousel = carousel(element, {
    arrows: false,
    autoplay: false,
    cssEase: 'cubic-bezier(0.770, 0.000, 0.175, 1.000)',
    dots: false,
    draggable: false,
    infinite: true,
    speed: 500
  });

  const resourceNav = carousel(
    `[data-resource-gallery-carousel-nav="${galleryId}"]`,
    {
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      infinite: false,
      dots: false,
      speed: 500,
      focusOnSelect: true,
      cssEase: 'cubic-bezier(0.770, 0.000, 0.175, 1.000)',
      asNavFor: `[data-resource-gallery-carousel="${galleryId}"]`,
      prevArrow:
        '<button type="button" class="slick-arrow slick-prev"><span class="icon icon--lg perc-icon-caret-up"></span></button>',
      nextArrow:
        '<button type="button" class="slick-arrow slick-next"><span class="icon icon--lg perc-icon-caret-down"></span></button>',
      vertical: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 6,
            prevArrow:
              '<button type="button" class="slick-arrow slick-prev"><span class="icon icon--lg perc-icon-caret-left"></span></button>',
            nextArrow:
              '<button type="button" class="slick-arrow slick-next"><span class="icon icon--lg perc-icon-caret-right"></span></button>',
            vertical: false
          }
        },
        {
          breakpoint: 892,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5,
            prevArrow:
              '<button type="button" class="slick-arrow slick-prev"><span class="icon icon--lg perc-icon-caret-left"></span></button>',
            nextArrow:
              '<button type="button" class="slick-arrow slick-next"><span class="icon icon--lg perc-icon-caret-right"></span></button>',
            vertical: false
          }
        },
        {
          breakpoint: 792,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            prevArrow:
              '<button type="button" class="slick-arrow slick-prev"><span class="icon icon--lg perc-icon-caret-left"></span></button>',
            nextArrow:
              '<button type="button" class="slick-arrow slick-next"><span class="icon icon--lg perc-icon-caret-right"></span></button>',
            vertical: false
          }
        },
        {
          breakpoint: 680,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            prevArrow:
              '<button type="button" class="slick-arrow slick-prev"><span class="icon icon--lg perc-icon-caret-left"></span></button>',
            nextArrow:
              '<button type="button" class="slick-arrow slick-next"><span class="icon icon--lg perc-icon-caret-right"></span></button>',
            vertical: false
          }
        },
        {
          breakpoint: 420,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            prevArrow:
              '<button type="button" class="slick-arrow slick-prev"><span class="icon icon--lg perc-icon-caret-left"></span></button>',
            nextArrow:
              '<button type="button" class="slick-arrow slick-next"><span class="icon icon--lg perc-icon-caret-right"></span></button>',
            vertical: false
          }
        }
      ]
    }
  );
});

// Full Width Slim Dropdown Functionality
$(() => {
  $('#fws-dropdown').on('change', function () {
    const link = $(this).find(':selected').attr('data-link');
    window.location.href = link;
  });
});
